import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCategory, deleteCategory, getAllCategory, updateCategory } from '../../redux/rtk/features/masters/categorySlice';
import PageTitle from '../page-header/PageHeader';

const CategoryMaster = () => {
  const { Title } = Typography;
  
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.category);

  useEffect(() => {
    dispatch(getAllCategory());
  }, [dispatch]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (editingCategory) {
        // Update existing category
        const result = await dispatch(
          updateCategory({ id: editingCategory.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllCategory());
        } else {
          message.error('Error updating category!');
        }
      } else {
        // Add new category
        const result = await dispatch(addCategory(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllCategory());
        } else {
          message.error('Error adding category!');
        }
      }
      form.resetFields();
      setEditingCategory(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update category!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteCategory(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllCategory()); // Refresh table data
      } else {
        message.error('Error deleting category!');
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Category',
      dataIndex: 'categoryName',
      key: 'name',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {
            setEditingCategory(record);
            form.setFieldsValue(record);
          }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this category?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingCategory ? 'Edit Category' : 'Add Category'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="category-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleSubmit}
              autoComplete="off"
            >
              <Form.Item
                name="categoryName"
                label="Category"
                rules={[{ required: true, message: 'Please enter a category!' }]}
              >
                <Input placeholder="Enter category" />
              </Form.Item>
              <Button type="primary" block htmlType="submit">
                {editingCategory ? 'Update Category' : 'Add Category'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Categories List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CategoryMaster;
